import React, { useState } from "react";
import "./DevelopmentVideoSlider.scss";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";
// import FancyVideo from "react-videojs-fancybox";
import { FaPlay } from "react-icons/fa";
import Slider from "react-slick";
import VideoPlayModal from "components/video-play-modal/VideoPlayModal";

const DevelopmentVideoSlider = ({ sliderItem }) => {
  const [modalSHow, setModalShow] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState("");
  const [readMore, setReadMore] = useState(false);

  const handleShow = () => {
    setModalShow(true);
  };
  const handleClose = () => {
    setModalShow(false);
  };
  var DevelopmentSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 900,
    autoplay: true,
    autoplaySpeed: 8000,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  return (
    <section className="development_slider spacing">
      <div className="container">
        <Slider {...DevelopmentSlider}>
          {sliderItem &&
            sliderItem.map((item, index) => {
              return (
                <div className="item" key={index}>
                  <div className="development_slider_card">
                    <div className="content">
                      <h6>{item.question}</h6>
                      <h3>Join Shubhra Ranjan IAS Study - The Best IAS Coaching in Delhi</h3>
                      {/* <p>{item.description?.slice(0, 350)}</p> */}
                      <div className="hardcoded-description" >
                        {!readMore ? (
                          <>
                            <p className="hardcoded-descriptionpara">
                              For more than a decade, Shubhra Ranjan IAS Study has been an <strong>IAS
                              coaching center in Delhi for civil services preparation,</strong> trusted by
                              thousands of aspirants preparing for UPSC. As a leading <strong>Delhi IAS
                              coaching center,</strong> we have consistently produced top results year after
                              year.
                            </p>

                            <button
                              onClick={() => setReadMore(true)}
                              className="readmore-btn"
                              style={{
                                marginTop: "10px",
                                fontSize: "13px",
                                color: "#4971b2",
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                                padding: 0,
                              }}
                            >
                              Read More →
                            </button>
                          </>
                        ) : (
                          <>
                            <p className="hardcoded-descriptionpara">
                              For more than a decade, Shubhra Ranjan IAS Study has been an <strong>IAS
                              coaching center in Delhi for civil services preparation,</strong> trusted by
                              thousands of aspirants preparing for UPSC. As a leading <strong>Delhi IAS
                              coaching center,</strong> we have consistently produced top results year after
                              year.
                            </p>

                            <p className="hardcoded-descriptionpara">
                              Our institute is known for delivering structured classroom programs,
                              high-quality study material, and result-oriented teaching. Over the last
                              10 years, <strong>8–10% of the UPSC final list</strong> has included students from our
                              regular batches, making us one of the <strong>trusted institutes for UPSC and
                              MPSC </strong>preparation in India.
                            </p>

                            <p className="hardcoded-descriptionpara" style={{marginTop:"8px"}}>Our successful candidates include:</p>

                            <ul className="custom-status-list">
                              <li><span className="status-dot"></span> Tina Dabi (AIR 1, 2015)</li>
                              <li><span className="status-dot"></span> Ishita Kishore (AIR 1, 2023)</li>
                              <li><span className="status-dot"></span> Anmol Singh Bedi (AIR 2, 2016)</li>
                              <span>… and many more proud achievers.</span>
                            </ul>

                            <p className="hardcoded-descriptionpara">
                              Build your IAS journey with India’s most trusted institute and proven
                              teaching methodology.
                            </p>

                            <button
                              onClick={() => setReadMore(false)}
                              className="readmore-btn"
                              style={{
                                marginTop: "10px",
                                fontSize: "13px",
                                color: "#4971b2",
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                                padding: 0,
                              }}
                            >
                              Read Less ↑
                            </button>
                          </>
                        )}
                      </div>

                      {item.url && (
                        <div className="button_wrap fill">
                          {/* <h1 style={{fontSize:"12px"}}>Best IAS Coaching & UPSC Classes in Delhi, India</h1> */}
                          <Link to={`${item.url}`} className="button">
                            {/* {item.url} */}
                            Register Now
                            <span className="icon">
                              <BsArrowRight />
                            </span>
                          </Link>
                        </div>
                      )}
                    </div>
                    <div className="image_wrap">
                      <p
                        className="playicon"
                        onClick={() => {
                          setSelectedVideo(item.video);
                          handleShow();
                        }}
                      >
                        <span className="videoplay_icon">
                          <FaPlay />
                        </span>
                      </p>

                      {/* <FancyVideo source={item.video} poster={item.image}  /> */}
                      <img src={item.image} alt="" loading="lazy" />
                    </div>
                  </div>
                </div>
              );
            })}
        </Slider>
        <VideoPlayModal
          modalShow={modalSHow}
          modalHide={handleClose}
          video={selectedVideo}
        />
      </div>
    </section>
  );
};

export default DevelopmentVideoSlider;
